import conveniadoMixin from '@/src/mixins/conveniadoMixin'
import OrcamentoService from '@src/services/orcamentos';

const table = [{ procedimento: 'Procedimento' }]

const orcamentoMixin = {
  mixins: [conveniadoMixin],
  data() {
    return {
    orcamentoLoading: true,
      conveniados: [],
      orcamentoFields: [
        {
          key: 'select',
          label: '',
        },
        {
          key: 'procedimento',
          label: 'Procedimento',
        },
      ],
      orcamentoListFields: [
        {
          key: 'actions',
          label: ''
        },
        {
          key: 'cliente',
          label: 'Cliente',
        },
        {
          key: 'data',
          label: 'Data',
        },
      ],
      orcamentos: [],
      conveniados: [],
      grupo: null,
    }
  },
  methods: {
    async handleGetConveniados(){
      this.orcamentos = []
      this.orcamentoFields = [
        {
          key: 'select',
          label: '',
        },
        {
          key: 'procedimento',
          label: 'Procedimento',
        },
      ],
      this.loadConveniados(this.grupo)
            .then(conveniados => {
              this.conveniados = conveniados
                conveniados.map(conveniado => {
                    this.orcamentoFields.push({
                        key: `${conveniado._id}`,
                        label: conveniado.nome
                    })
                })
            })
    },
    loadOrcamentos() {
      return OrcamentoService
              .list()
              .then(response => response.data)
              .catch(error => error)
    },
    loadOrcamentosByFilter(cliente) {
      return OrcamentoService
              .filter(cliente)
              .then(response => response.data)
              .catch(error => error)
    },
    async updateOrcamento(id, orcamento) {
      await OrcamentoService.update(id, orcamento)
  },
    async registerOrcamento(orcamento) {
        await OrcamentoService.create(orcamento)
    },
    async deleteOrcamento(id) {
      await OrcamentoService.remove(id)
    },
  },
}

export default orcamentoMixin

